import { Component, ErrorInfo, PropsWithChildren } from 'react';

import { FallbackScreen } from './FallbackScreen';

export type ErrorBoundaryProps = PropsWithChildren;

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('렌더링 오류', error, errorInfo);
  }

  private handleRetry = (): void => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return <FallbackScreen reason="unknown" onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}
